import { Col, Row, } from "antd";
import StaticPageBanner from "apps/Common/StaticPageBanner";
import { useGetContractByType } from "apps/CustomerPanel/Ad/ServerSideStates";
import { Helmet } from "react-helmet-async";


const CookiPolicyAgreement = () => {


  const contract = useGetContractByType("1002");
  const html = contract?.data?.data?.content || "";
  return (

    <>
      <Col xs={24} className="!overflow-hidden" >
        <Row gutter={[0, 20]}>
          <Col span={24}>
            <StaticPageBanner
              title={"Çerez Politikası"}
              // title= {pageDetails?.data?.data?.name || ""}
              description={"Aşağıda Gizlilik Politikamızı görüntüleyebilir, gizlilik uygulamalarımız hakkında bilgi edinebilir ve kişisel bilgilerinizi çevrimiçi olarak nasıl kontrol edebileceğinizi ve koruyabileceğinizi öğrenebilirsiniz."}
            />
            <Helmet>
              <title className="capitalize">{"Çerezler"}</title>
            </Helmet>

          </Col>

          <Col xs={24}>
            <Row className="!px-2 lg:!px-6 xxl:!px-16" gutter={[20, 20]}>
              <Col xs={24}>
                <div dangerouslySetInnerHTML={{ __html: html }} />
              </Col>
            </Row>
          </Col>
        </Row>
      </Col>
    </>
  );
};

export default CookiPolicyAgreement;
